import { render } from "./Paulina.vue?vue&type=template&id=245d8aa6&ts=true"
import script from "./Paulina.vue?vue&type=script&lang=ts"
export * from "./Paulina.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__